


































import { Component, Inject, Vue } from 'vue-property-decorator'
import { GamificationSettingsAPI } from '@/api/backend-client'
import { cloneDeep, isEqual } from 'lodash'
import { GamificationSettings } from '@/api/model/gamification-settings'
import ModuleIframe from '@/components/ui/ModuleIframe.vue'

@Component({
    components: { ModuleIframe },
})
export default class CompanySettingsGamification extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    gamificationSettings: GamificationSettings = null
    loading: boolean = false

    async created() {
        await this.reload()
    }

    async reload() {
        try {
            this.loading = true

            this.gamificationSettings = await GamificationSettingsAPI.get(this.$currentCompany.id, true)
        } finally {
            if (!this.gamificationSettings) {
                this.gamificationSettings = cloneDeep(this.$currentCompany.gamificationSettings)
                this.gamificationSettings.id = this.$currentCompany.id
                this.gamificationSettings.company = this.$currentCompany.resourceIdentifier
                this.gamificationSettings = await GamificationSettingsAPI.create(this.gamificationSettings)
            }

            this.$currentCompany.gamificationSettings = cloneDeep(this.gamificationSettings)

            this.loading = false
        }
    }

    async save() {
        try {
            this.loading = true
            await GamificationSettingsAPI.update(this.gamificationSettings.id, this.gamificationSettings)
            await this.reloadCompany()
            await this.reload()

        } finally {
            this.loading = false
        }
    }

    get hasChanges(): boolean {
        if (!this.gamificationSettings) {
            return false
        }

        return isEqual(this.$currentCompany.gamificationSettings, this.gamificationSettings) === false
    }
}
